import Image from "next/image";
import { useCallback } from "react";

import { AdResponseDto } from "@/hooks/api/generated";

interface ITopPageProps {
  advert: AdResponseDto;
  handleTrackClick: (campaignPlaceholderId: number) => void;
}

export function Ad({ advert, handleTrackClick }: ITopPageProps): JSX.Element {
  const handleClick = useCallback(() => {
    if (advert.campaignPlaceholderId) {
      handleTrackClick(advert.campaignPlaceholderId);
    }
    window.open(advert?.clickUrl ?? "", "_blank");
  }, [advert.campaignPlaceholderId, advert?.clickUrl, handleTrackClick]);

  return (
    <div className="flex justify-center items-center mx-auto">
      <Image
        src={advert?.image?.name ?? ""}
        alt={advert?.imageAltText ?? ""}
        width={advert.width}
        height={advert.height}
        style={{ width: `${advert.width}px`, height: `${advert.height}px` }}
        className="object-cover cursor-pointer"
        onClick={handleClick}
      />
    </div>
  );
}
